import { motion } from "framer-motion";
import { Eye, Target, CheckCircle2 } from "lucide-react";

export const VisionMission = ({ content }) => {
  return (
    <section
      id="visi-misi"
      data-testid="vision-mission-section"
      className="relative py-20 md:py-32 bg-background overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            Visi & Misi
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            Arah & Komitmen Kami
          </h2>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">
            Landasan yang menggerakkan setiap langkah kami dalam mendidik dan membimbing generasi
            penerus bangsa.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            data-testid="visi-card"
            className="lg:col-span-2 relative rounded-3xl bg-gradient-to-br from-sky-500 to-sky-700 p-8 sm:p-10 text-white overflow-hidden shadow-xl shadow-sky-500/20"
          >
            <div className="absolute -top-10 -right-10 w-48 h-48 bg-white/10 rounded-full blur-2xl" />
            <div className="relative">
              <div className="w-14 h-14 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center mb-6">
                <Eye className="w-7 h-7" />
              </div>
              <h3 className="text-2xl font-bold mb-4">Visi</h3>
              <p className="text-sky-50 leading-relaxed text-lg">{content.visi}</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            data-testid="misi-card"
            className="lg:col-span-3 rounded-3xl bg-white border border-slate-100 p-8 sm:p-10 shadow-xl shadow-slate-200/50"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center">
                <Target className="w-7 h-7 text-amber-500" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900">Misi</h3>
            </div>
            <ul className="space-y-4">
              {content.misi.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.15 + i * 0.08 }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle2 className="w-6 h-6 text-sky-500 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-600 leading-relaxed">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
